/* Raghu  31/10/2022   3075154998   changed the icons in the table
Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Suresh Peddavoora 11/03/2022 3075154998 Table Pagination Tab Responsive Fixes

*/
import React from 'react';
import {MTableBody, MTableBodyRow} from 'material-table';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import DialogBox from '../../../../../components/DialogBox';
import AddFilters from './DialogViewContent/AddFilter';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {fetchFilter} from '../../../../../redux/reducers/EnableFramework/Filter';
import {useDispatch} from 'react-redux';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'inherit',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
      textAlign: 'center',
    },
    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
  },
});

export default function FilterGroupTable({selectedRows, setSelectedRows}) {
  const columns = [
    {
      title: 'S.No',
      render: (rowData) =>
        rowData.tableData.id ? rowData.tableData.id + 1 : rowData.tableData.id === 0 ? 1 : '',
    },
    {
      title: 'Filter code',
      field: 'name',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];

  const dispatch = useDispatch();
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [filterCode, setFilterCode] = React.useState(false);
  const [filterCodeName, setFilterCodeName] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState({});
  const [rows, setRows] = React.useState(defaultRows);
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...selectedRows];
      const temp = selectedRows[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setSelectedRows(copyRows);
    }
  };
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    const filteredArr = [...selectedRows].filter((row) => row.id !== deleteData.id);
    setSelectedRows(filteredArr);
    setIsDelete(false);
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Filter Group"
        value={`Are you sure you want to delete this filter code: ${deleteData.name} ?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        <div
          className={`mb-4 global-field-table custom-table ${classes.letterTable} drag-and-drop-table custom-map-sec`}
        >
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={selectedRows}
            options={{
              search: false,
              selection: false,
              pageSize: rows,
              toolbar: false,
              pageSizeOptions: tablePageRows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">

                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Body: (props) => (
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                      {(provided) => (
                        <div ref={provided.innerRef}>
                          <MTableBody {...props} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              ),
              Row: (props) => (
                <Draggable
                  draggableId={props.data.tableData.id.toString()}
                  index={props.data.tableData.id}
                >
                  {(provided) => (
                    <div
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                    >
                      <MTableBodyRow {...props} />
                    </div>
                  )}
                </Draggable>
              ),
            }}
            actions={[
              {
                icon: () => <VisibilityOutlinedIcon />,
                tooltip: 'view',
                onClick: (event, rowData) => {
                  dispatch(fetchFilter(rowData?.id));
                  setDialogOpen(true);
                  setFilterCode(rowData?.id);
                  setFilterCodeName(rowData?.name);
                },
              },
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
          />
        </div>
        <DialogBox
          title="View Filter"
          open={dialogOpen}
          maxWidth={'lg'}
          dialogClose={handleDialogClose}
        >
          <AddFilters filterCode={filterCode} filterCodeName={filterCodeName} />
        </DialogBox>
      </Grid>
    </>
  );
}
